<template>
  <main-container v-if="isBasicRoute">
    <a-card>
      <div class="type_list">
        <a-button class="item" :type="activeType == 1 ? 'primary' : ''" @click="toggleType(1)">
          服务条款
        </a-button>
        <a-button class="item" :type="activeType == 2 ? 'primary' : ''" @click="toggleType(2)">
          帮助中心
        </a-button>
        <a-button class="item" :type="activeType == 3 ? 'primary' : ''" @click="toggleType(3)">
          上门取件说明
        </a-button>
        <a-button class="add_item" type="primary" @click="goToCreateArticle">
          新增
        </a-button>
      </div>
      <a-table row-key="id" :columns="columns" :data-source="dataSource" :loading="loading" :pagination="false">
        <template slot="type" slot-scope="text">
          {{ text == 1 ? '服务条款' : text == 2 ? '帮助中心' : text == 3 ? '上门取件说明' : '' }}
        </template>
        <template slot="status" slot-scope="text, record, index">
          <a-switch :checked="record.status == 1" @change="onChangeStatus($event, record, index)" />
        </template>
        <template slot="action" slot-scope="record">
          <a-button
            type="link"
            @click="
              $router.push({ name: $routeName.addArticle, query: { id: record.id, type: activeType }, params: record })
            "
          >
            更新
          </a-button>
          <a-divider type="vertical"></a-divider>
          <a-popconfirm type="link" title="确认删除吗？" @confirm="handleDeleteConfirm(record)">
            <a-button type="link">
              删除
            </a-button>
          </a-popconfirm>
        </template>
      </a-table>
    </a-card>
  </main-container>
  <router-view v-else></router-view>
</template>

<script>
import Article from '@/api/article';
import Sortable from 'sortablejs';

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
  },
  {
    title: '文章分类',
    dataIndex: 'type',
    scopedSlots: { customRender: 'type' },
  },
  {
    title: '标题',
    dataIndex: 'title',
  },
  {
    title: '是否发布',
    scopedSlots: { customRender: 'status' },
  },
  {
    key: 'action',
    title: '操作',
    scopedSlots: { customRender: 'action' },
    width: 180,
  },
];

export default {
  name: 'ArticleList',
  data() {
    return {
      sortable: null, // 拖拽对象
      sortData: [], // 拖拽数据
      columns,
      loading: false,
      dataSource: [],
      activeType: 1,
    };
  },

  computed: {
    isBasicRoute() {
      return this.$route.name === this.$routeName.articleSetting;
    },
  },

  mounted() {
    this.loadList();
  },

  watch: {
    '$route.name'() {
      if (this.isBasicRoute) {
        this.loadList();
      }
    },
  },

  methods: {
    toggleType(type) {
      this.activeType = type;
      this.loadList();
    },

    goToCreateArticle() {
      this.$router.push({
        name: this.$routeName.addArticle,
        query: {
          type: this.activeType,
        },
      });
    },

    loadList() {
      this.loading = true;
      Article.CopywritingList({
        type: this.activeType,
      })
        .then(({ data }) => {
          this.dataSource = data;
          this.initSortable();
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 初始化拖拽
    initSortable() {
      this.sortData = [...this.dataSource];
      const el = document.querySelector('.ant-table-body tbody');
      //创建拖拽对象
      this.sortable = Sortable.create(el, {
        sort: true, //是否可进行拖拽排序
        animation: 150,
        //拖拽完成，移除拖拽之前的位置上的元素，在拖拽之后的位置上添加拖拽元素
        onEnd: ({ newIndex, oldIndex }) => {
          const val = this.sortData[oldIndex];
          this.sortData.splice(oldIndex, 1);
          this.sortData.splice(newIndex, 0, val);
          const arrid = [];
          this.sortData.map(d => arrid.push(d.id));
          console.log('拖拽完成-----', arrid, this.sortData);
          Article.Copywritingorder({
            copywriting_ids: arrid,
          }).then(({ retdata }) => {
            console.log('结果----', retdata);
          });
        },
      });
    },

    onChangeStatus(val, record, index) {
      this.dataSource[index].status = val ? 1 : 0;
      Article.CopywritingPublish({ id: record.id }).then(res => {
        if (res.status == 'success') {
          this.$message.success('操作成功');
          this.loadList();
        } else {
          this.$message.error('操作失败');
        }
      });
    },

    handleDeleteConfirm({ id }) {
      Article.CopywritingDelete({ id }).then(res => {
        if (res.status == 'success') {
          this.$message.success('删除成功');
          this.loadList();
        } else {
          this.$message.error('删除失败');
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.type_list {
  margin-bottom: 20px;

  .item {
    margin-right: 20px;
  }

  .add_item {
    float: right;
  }
}
</style>
